import { MyAccountActivity } from './MyAccountActivity';

export default MyAccountActivity;
